export function isStringInEnum<T extends string>(str: string, enumObj: { [key: string]: T }): str is T {
  return Object.values(enumObj).includes(str as T)
}
